module.exports = __webpack_public_path__ + "media/reskin-images/icon--user-circle-active-8281a054.svg";